import { ArrowRight, CheckCircle2, LoaderCircle } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function CheckoutSuccessPage() {
  const { refresh, user } = useAuth();
  const [polling, setPolling] = useState(true);
  useEffect(() => {
    let attempts = 0;
    const timer = window.setInterval(async () => {
      attempts += 1;
      await refresh();
      if (attempts >= 6) { window.clearInterval(timer); setPolling(false); }
    }, 1600);
    return () => window.clearInterval(timer);
  }, [refresh]);
  return <div className="checkout-success"><span className="success-icon"><CheckCircle2 /></span><span className="eyebrow">Payment received</span><h1>Your course is almost ready.</h1><p>{user?.plan ? `Programmer ${user.plan} is now unlocked on your account.` : "Stripe is confirming your payment. This usually takes only a few seconds."}</p>{polling && !user?.plan && <div className="confirming"><LoaderCircle />Confirming secure access…</div>}<Link className="button button-primary button-large" to="/dashboard">Go to dashboard <ArrowRight /></Link></div>;
}
